import { Component, OnInit } from '@angular/core';
import { StoreConvert } from 'src/app/model/StoreConvert';
import { HttpclientService } from 'src/app/services/httpclient.service';
import { FileExportService } from 'src/app/services/file-export.service';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from 'src/app/services/excel-file.service';
import { PdfFileService } from 'src/app/services/pdf-file.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog.service';
declare var $: any;

@Component({
  selector: 'app-partner-store',
  templateUrl: './partner-store.component.html',
  styleUrls: ['./partner-store.component.css']
})
export class PartnerStoreComponent implements OnInit {
  public loading: boolean;
  selectedpartner : String = "";
  selectedpartnerid : String = "";
  partners : any;
  search: string = "";
  selectedAllRow: boolean;
  config: any;
  count: number = 25;
  exportList: string[] = ['PDF', 'Excel'];
  selectedPartnerStores: any = [];
  exportModal: string;
  modalPopup : boolean=false;
  StoreConvert: StoreConvert[];
  serachdetails: StoreConvert[];
  StoreConvertdetails: StoreConvert[];
  clonedStoreConvertDetails: StoreConvert[];
  public intialStoreConvertList: StoreConvert[];

  isstoreupdated : string="";
  updatedstoreconvert : boolean;
  jobberCustId:number;
  sapClntCd:string;
  sapJobberPayerNum:string;
  sapCustNum:string;
  sapCustShipToName:string;

  isJobberCustIdSortCollapsedUpArrow:boolean;
  isJobberCustIdSortCollapsedDownArrow:boolean;

  isSapClntCdSortCollapsedUpArrow:boolean;
  isSapClntCdSortCollapsedDownArrow:boolean;

  isSapJobberPayerNumSortCollapsedUpArrow:boolean;
  isSapJobberPayerNumSortCollapsedDownArrow:boolean;

  isSapCustNumSortCollapsedUpArrow:boolean;
  isSapCustNumSortCollapsedDownArrow:boolean;

  isSapCustShipToNameSortCollapsedUpArrow:boolean;
  isSapCustShipToNameSortCollapsedDownArrow:boolean;

  constructor(private httpclientService: HttpclientService,public fileExportService: FileExportService,
    public appSettingService: AppSettingService,private pipe: PoOrderByPipe,public pdfFileService: PdfFileService,
    public excelFileService: ExcelFileService, public datePipe: DatePipe,  private confirmDialogService: ConfirmDialogService) { 
    this.config = {
      currentPage: 1,
      itemsPerPage: 25
    };
  }

  
  ngOnInit() { 
    $(document).ready(
      () => {
        let searchInp = $(".searchContr .searchInput");
        let searchCloseIcon = $(".searchCloseIcon")
        $(searchInp).on("focus", function () {
          $(".searchIcon").addClass("searchIconActive")
          $(".searchCloseIcon").fadeIn("slow")
        })
        $(searchInp).on("blur", function () {
          $(".searchIcon").removeClass("searchIconActive")
          $(".searchCloseIcon").fadeOut("slow")
        })
        $(searchCloseIcon).hover(function () {
          $(searchCloseIcon).toggleClass("searchCloseIconFocus")
        })
        $(searchCloseIcon).on("click", function () {
          $(".searchContr .searchCloseIcon").val("");
          $(".searchInput").val("");

        })
        
      }
    )
  //   this.loading=true;
  //   this.httpclientService.getPartnerListMSO().subscribe(
  //     data => {
  //       this.partners = data;
  //     }
  // );
    this.getPartnerDataList();
  this.exportModal = this.appSettingService.exportList[0];
  this.onSearch();
  this.fileExportService.selectedStoreConvertData=[];
  }
  filterRecordsBasedOnPartner(){
    if(this.selectedpartner == "" ||  this.selectedpartner == null || this.selectedpartner == undefined){
      this.StoreConvertdetails=this.intialStoreConvertList;
    }else{
    this.StoreConvertdetails=this.intialStoreConvertList;
    var edpardetailsBasedOnPartnerSearch : StoreConvert[]=[];
    var edpardetailsBasedOnPartnerSearchForLoop : StoreConvert[]=[];
    edpardetailsBasedOnPartnerSearchForLoop=this.StoreConvertdetails;
    var len = edpardetailsBasedOnPartnerSearchForLoop.length;
    for(var i=0; i<len; i++){
     if(this.StoreConvertdetails[i].ediTpId == this.selectedpartner){
      edpardetailsBasedOnPartnerSearch.push(edpardetailsBasedOnPartnerSearchForLoop[i]);
      }
    }
      var filterLen = edpardetailsBasedOnPartnerSearch.length;
      this.StoreConvertdetails=[];
      this.StoreConvertdetails=edpardetailsBasedOnPartnerSearch;
  }
    
  }

  getPartnerDataList() {
    this.loading = true;
    if (this.appSettingService.partnerMSOGlobelList === null || this.appSettingService.partnerMSOGlobelList === undefined ) {
      this.httpclientService.getPartnerList().subscribe(
        data => {
          this.appSettingService.partnerMSOGlobelList = data;
          this.partners = data;
          this.loading = false;
        }
      );

      console.log('Partner is null from backend' + this.appSettingService.partnerMSOGlobelList);
      } else {
        this.partners = this.appSettingService.partnerMSOGlobelList;
        this.loading = false;
        console.log('Partner is not null from frontend' + this.appSettingService.partnerMSOGlobelList);
      }
  }

  ChangeSortOrder(exportData) {
    this.exportModal = exportData;
  }
  pressingOK(){
    this.modalPopup=false;
    this.updatedstoreconvert = false;
    this.search="";
    // this.onSearch();
    this.ngOnInit();

  }
  pressingCancel(){
    this.modalPopup=false;
  }
  modalPopupExport : boolean=false;
  modalPopupString: string;
  pressingOKExport(){
    this.modalPopupExport=false;
  }
  export() {
    let flag:boolean = false;
    if (this.StoreConvertdetails ==null || this.StoreConvertdetails == undefined || this.StoreConvertdetails.length === 0) {
      this.modalPopupString="No Data to Export";
      this.modalPopupExport=true;
      return;
    }
    if (this.fileExportService.selectedStoreConvertData.length === 0) {
      this.StoreConvert = [];
      flag=true;
      this.StoreConvertdetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.StoreConvert.push(pdto);
      });
      this.StoreConvertdetails = this.StoreConvert;
      this.fileExportService.selectedStoreConvertData = this.StoreConvert;
    }
      if (this.exportModal === 'PDF') {
        this.pdfFileService.exportPartnerStore('Partner Store');
      } else if (this.exportModal === 'Excel') {
        this.selectedPartnerStores = [];
        this.fileExportService.selectedStoreConvertData.forEach(pdto => {
          if (pdto.rowCheck) {
            this.selectedPartnerStores.push({
              'Jobber Cust ID': `` + `${pdto.jobberCustId}`, 'SAP Client Code': `${pdto.sapClntCd}`, 'SAP Jobber Payer Num': `${pdto.sapJobberPayerNum}`,
              'SAP Cust Num': `${pdto.sapCustNum}`, 'SAP Cust Ship Name': `` + `${pdto.sapCustShipToName}`
            });
          }
        });
        this.excelFileService.exportPartnerStoreExcel(this.selectedPartnerStores, 'Partner Store');
      }
      if(flag){
        this.StoreConvert = [];
        this.StoreConvertdetails.forEach(pdto => {
          pdto.rowCheck = false;
          this.StoreConvert.push(pdto);
        });
        this.StoreConvertdetails = this.StoreConvert;
        this.fileExportService.selectedStoreConvertData = [];
      }
  }

  pageChanged(event) {
    this.config.currentPage = event;
  }

  changerecordperpage(value) {

    this.config.itemsPerPage = value;
    this.count = value;
  }
filteredData : any[]=[];

  onChangePartner(){
    this.filteredData =[];
    this.selectedpartnerid=null
    if(this.intialStoreConvertList==undefined||this.intialStoreConvertList==null||this.intialStoreConvertList.length<1)
    {
      this.loading = true;
      this.httpclientService.getStoreConvertDetails(this.search).then(
      (data)=> {
        this.loading = false;
          this.serachdetails=data;
          this.intialStoreConvertList = data;
          this.StoreConvertdetails=[];
          this.StoreConvertdetails=this.serachdetails;
          this.clonedStoreConvertDetails= Object.assign([{}], this.serachdetails);
          this.clearAllSort();
          this.partners.forEach(element => {
            if(element.partnerName==this.selectedpartner)
            this.selectedpartnerid=element.partnerNumber;
          });
        this.intialStoreConvertList.forEach(element => {
        if(this.selectedpartnerid!=undefined&&this.selectedpartnerid!=null&&element.sapJobberPayerNum==this.selectedpartnerid)
        this.filteredData.push(element);
      });
      this.StoreConvertdetails=[];
      if(this.filteredData!=null&&this.filteredData.length>0){
        this.serachdetails=this.filteredData;
                this.StoreConvertdetails=this.serachdetails;
                this.clonedStoreConvertDetails= Object.assign([{}], this.serachdetails);
                this.clearAllSort();
      }else if(this.selectedpartnerid==undefined||this.selectedpartnerid==null){
        this.serachdetails=this.intialStoreConvertList;
        this.StoreConvertdetails=this.serachdetails;
        this.clonedStoreConvertDetails= Object.assign([{}], this.serachdetails);
        this.clearAllSort();
      }
      }
  )
    }else{
      this.partners.forEach(element => {
        if(element.partnerName==this.selectedpartner)
        this.selectedpartnerid=element.partnerNumber;
      });
    this.intialStoreConvertList.forEach(element => {
    if(this.selectedpartnerid!=undefined&&this.selectedpartnerid!=null&&element.sapJobberPayerNum==this.selectedpartnerid)
    this.filteredData.push(element);
  });
  this.StoreConvertdetails=[];
  if(this.filteredData!=null&&this.filteredData.length>0){
    this.serachdetails=this.filteredData;
            this.StoreConvertdetails=this.serachdetails;
            this.clonedStoreConvertDetails= Object.assign([{}], this.serachdetails);
            this.clearAllSort();
  }else if(this.selectedpartnerid==undefined||this.selectedpartnerid==null){
    this.serachdetails=this.intialStoreConvertList;
    this.StoreConvertdetails=this.serachdetails;
    this.clonedStoreConvertDetails= Object.assign([{}], this.serachdetails);
    this.clearAllSort();
  }
    }
  }

  cancelsearch(){
    this.isBlank=""
    this.StoreConvertdetails=this.clonedStoreConvertDetails;
  }
  clearMessage(){
    this.isBlank=""
  }
  onChangeSearch(){
    this.selectedpartner="Pick a Partner";
  }

  isBlank : string="";
  onSearch1(searchingData){
    if(searchingData.value === "" || searchingData.value === undefined || searchingData.value === null){
      this.isBlank="Please Enter Searching Data";
      return;
    }
    var filteredSerachDetails: StoreConvert[]=[];
    var inputSearchingData = searchingData.value;
    var inputSearchingDataCheck = inputSearchingData.toLowerCase();
    var jobberCustId,sapClntCd,sapJobberPayerNum,sapCustNum,sapCustShipToName;
    
    for(var partnerStore of this.serachdetails){
      if(partnerStore.jobberCustId != null && partnerStore.jobberCustId != undefined && partnerStore.jobberCustId.toString() !=""){
        jobberCustId =partnerStore.jobberCustId;
      }else{
        jobberCustId="";
      }
    if(partnerStore.sapClntCd != null && partnerStore.sapClntCd != undefined && partnerStore.sapClntCd !=""){
      sapClntCd = partnerStore.sapClntCd.toLowerCase();
      }else{
        sapClntCd="";
      }
    if(partnerStore.sapJobberPayerNum != null && partnerStore.sapJobberPayerNum != undefined && partnerStore.sapJobberPayerNum !=""){
      sapJobberPayerNum = partnerStore.sapJobberPayerNum.toLowerCase();
      }else{
        sapJobberPayerNum="";
      }
    if(partnerStore.sapCustNum != null && partnerStore.sapCustNum != undefined && partnerStore.sapCustNum !=""){
      sapCustNum = partnerStore.sapCustNum.toLowerCase();
      }else{
        sapCustNum="";
      }
    if(partnerStore.sapCustShipToName != null && partnerStore.sapCustShipToName != undefined && partnerStore.sapCustShipToName !=""){
      sapCustShipToName = partnerStore.sapCustShipToName.toLowerCase();
      }else{
        sapCustShipToName="";
      }
    
      if(jobberCustId.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(partnerStore);
      }
      else if(sapClntCd.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(partnerStore);
      }
      else if(sapJobberPayerNum.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(partnerStore);
      }
      else if(sapCustNum.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(partnerStore);
      }
      else if(sapCustShipToName.includes(inputSearchingDataCheck)){
        filteredSerachDetails.push(partnerStore);
      }


    }
    let size = filteredSerachDetails.length;
    if(size !=0){
    this.StoreConvertdetails=[];
    this.StoreConvertdetails=filteredSerachDetails;
    }else{
      this.isBlank="No Record Found";
      this.StoreConvertdetails=this.intialStoreConvertList;
    }

  }
  onSearch(){
    this.clearAllSelection();
    this.onChangeSearch();
    // if(this.search != undefined && this.search != null && this.search != "" ){
      if(this.search != undefined && this.search != null){
      this.loading=true;
    this.httpclientService.getStoreConvertDetails(this.search).then(
      data => {
        this.selectedpartner="";
        this.loading=false;
          this.serachdetails=data;
          this.intialStoreConvertList = data;
          this.StoreConvertdetails=[];
          this.StoreConvertdetails=this.serachdetails;
          this.clonedStoreConvertDetails= Object.assign([{}], this.serachdetails);
          this.clearAllSort();
      }
  )}
  }

  clearAllSort() {
    this.isJobberCustIdSortCollapsedUpArrow=true;
    this.isJobberCustIdSortCollapsedDownArrow=true;
    this.isSapClntCdSortCollapsedUpArrow=true;
    this.isSapClntCdSortCollapsedDownArrow=true;
    this.isSapJobberPayerNumSortCollapsedUpArrow=true;
    this.isSapJobberPayerNumSortCollapsedDownArrow=true;
    this.isSapCustNumSortCollapsedUpArrow=true;
    this.isSapCustNumSortCollapsedDownArrow=true;
    this.isSapCustShipToNameSortCollapsedUpArrow=true;
    this.isSapCustShipToNameSortCollapsedDownArrow=true;
  }
  clearStoreConvertSelection: StoreConvert[];
  clearAllSelection() {
    this.selectedAllRow = false;
    this.clearStoreConvertSelection = [];
    if(this.StoreConvertdetails!=null && this.StoreConvertdetails.length>0){
      this.StoreConvertdetails.forEach(pdto => {
        pdto.rowCheck = false;
        this.clearStoreConvertSelection.push(pdto);
      });
    }
    
    this.StoreConvertdetails = this.clearStoreConvertSelection;
  }

  onSelectAllCust(values: any) {

    this.StoreConvert = [];
    if (values.currentTarget.checked) {
      this.StoreConvertdetails.forEach(pdto => {
        pdto.rowCheck = true;
        this.StoreConvert.push(pdto);
      });
      this.StoreConvertdetails = this.StoreConvert;
      this.fileExportService.selectedStoreConvertData = this.StoreConvert;
    } else {
      this.StoreConvertdetails.forEach(pdto => {
        pdto.rowCheck = false;
        this.StoreConvert.push(pdto);
      });
      this.StoreConvertdetails = this.StoreConvert;
      this.fileExportService.selectedStoreConvertData = [];
    }

  }

  onSelect(selectedItem: any, values: any) {
    let checkStaus = true;
    if (values.currentTarget.checked) {

      this.fileExportService.selectedStoreConvertData.push(selectedItem);
    } else if (!values.currentTarget.checked) {

      this.fileExportService.selectedStoreConvertData = this.fileExportService.selectedStoreConvertData.filter(obj => obj !== selectedItem);
     
    }

    if(this.fileExportService.selectedStoreConvertData.length === this.StoreConvertdetails.length){
      this.selectedAllRow = true;
    }else{ 
      this.selectedAllRow = false;
    }
    

}

  sortArry: StoreConvert[];
  onChangeSort(event: any, upDown: boolean, propertyName: string) {
    this.intialStoreConvertList=this.StoreConvertdetails;
    if (propertyName === 'jobberCustId' ) {
      this.isSapClntCdSortCollapsedUpArrow=true;
      this.isSapClntCdSortCollapsedDownArrow=true;
      this.isSapJobberPayerNumSortCollapsedUpArrow=true;
      this.isSapJobberPayerNumSortCollapsedDownArrow=true;
      this.isSapCustNumSortCollapsedUpArrow=true;
      this.isSapCustNumSortCollapsedDownArrow=true;
      this.isSapCustShipToNameSortCollapsedUpArrow=true;
      this.isSapCustShipToNameSortCollapsedDownArrow=true;
      if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, upDown);
    this.StoreConvertdetails = [];
    this.StoreConvertdetails = this.sortArry;
    this.isJobberCustIdSortCollapsedUpArrow = !this.isJobberCustIdSortCollapsedUpArrow;
    this.isJobberCustIdSortCollapsedDownArrow = true;
} else {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, upDown);
  this.StoreConvertdetails = [];
  this.StoreConvertdetails = this.sortArry;
  this.isJobberCustIdSortCollapsedDownArrow = !this.isJobberCustIdSortCollapsedDownArrow;
  this.isJobberCustIdSortCollapsedUpArrow = true;
}
  } else if (propertyName === 'sapClntCd' ) {
    this.isJobberCustIdSortCollapsedUpArrow=true;
    this.isJobberCustIdSortCollapsedDownArrow=true;
    this.isSapJobberPayerNumSortCollapsedUpArrow=true;
    this.isSapJobberPayerNumSortCollapsedDownArrow=true;
    this.isSapCustNumSortCollapsedUpArrow=true;
    this.isSapCustNumSortCollapsedDownArrow=true;
    this.isSapCustShipToNameSortCollapsedUpArrow=true;
    this.isSapCustShipToNameSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, true);
    this.StoreConvertdetails = [];
    this.StoreConvertdetails = this.sortArry;
    this.isSapClntCdSortCollapsedUpArrow = !this.isSapClntCdSortCollapsedUpArrow;
    this.isSapClntCdSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, false);
  this.StoreConvertdetails = [];
  this.StoreConvertdetails = this.sortArry;
  this.isSapClntCdSortCollapsedDownArrow = !this.isSapClntCdSortCollapsedDownArrow;
  this.isSapClntCdSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'sapJobberPayerNum' ) {
    this.isJobberCustIdSortCollapsedUpArrow=true;
    this.isJobberCustIdSortCollapsedDownArrow=true;
    this.isSapClntCdSortCollapsedUpArrow=true;
    this.isSapClntCdSortCollapsedDownArrow=true;
    this.isSapCustNumSortCollapsedUpArrow=true;
    this.isSapCustNumSortCollapsedDownArrow=true;
    this.isSapCustShipToNameSortCollapsedUpArrow=true;
    this.isSapCustShipToNameSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, true);
    this.StoreConvertdetails = [];
    this.StoreConvertdetails = this.sortArry;
    this.isSapJobberPayerNumSortCollapsedUpArrow = !this.isSapJobberPayerNumSortCollapsedUpArrow;
    this.isSapJobberPayerNumSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, false);
  this.StoreConvertdetails = [];
  this.StoreConvertdetails = this.sortArry;
  this.isSapJobberPayerNumSortCollapsedDownArrow = !this.isSapJobberPayerNumSortCollapsedDownArrow;
  this.isSapJobberPayerNumSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'sapCustNum' ) {
    this.isJobberCustIdSortCollapsedUpArrow=true;
    this.isJobberCustIdSortCollapsedDownArrow=true;
    this.isSapClntCdSortCollapsedUpArrow=true;
    this.isSapClntCdSortCollapsedDownArrow=true;
    this.isSapJobberPayerNumSortCollapsedUpArrow=true;
    this.isSapJobberPayerNumSortCollapsedDownArrow=true;
    this.isSapCustShipToNameSortCollapsedUpArrow=true;
    this.isSapCustShipToNameSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, true);
    this.StoreConvertdetails = [];
    this.StoreConvertdetails = this.sortArry;
    this.isSapCustNumSortCollapsedUpArrow = !this.isSapCustNumSortCollapsedUpArrow;
    this.isSapCustNumSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, false);
  this.StoreConvertdetails = [];
  this.StoreConvertdetails = this.sortArry;
  this.isSapCustNumSortCollapsedDownArrow = !this.isSapCustNumSortCollapsedDownArrow;
  this.isSapCustNumSortCollapsedUpArrow = true;
} 
  } else if (propertyName === 'sapCustShipToName' ) {
    this.isJobberCustIdSortCollapsedUpArrow=true;
    this.isJobberCustIdSortCollapsedDownArrow=true;
    this.isSapClntCdSortCollapsedUpArrow=true;
    this.isSapClntCdSortCollapsedDownArrow=true;
    this.isSapJobberPayerNumSortCollapsedUpArrow=true;
    this.isSapJobberPayerNumSortCollapsedDownArrow=true;
    this.isSapCustNumSortCollapsedUpArrow=true;
    this.isSapCustNumSortCollapsedDownArrow=true;
    if (upDown) {
    this.sortArry = [];
    this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, true);
    console.log("property"+propertyName);
    this.StoreConvertdetails = [];
    this.StoreConvertdetails = this.sortArry;
    this.isSapCustShipToNameSortCollapsedUpArrow = !this.isSapCustShipToNameSortCollapsedUpArrow;
    this.isSapCustShipToNameSortCollapsedDownArrow = true;
} else {
  this.sortArry = []; 
  this.sortArry = this.pipe.transform(this.intialStoreConvertList, propertyName, false);
  this.StoreConvertdetails = [];
  this.StoreConvertdetails = this.sortArry;
  this.isSapCustShipToNameSortCollapsedDownArrow = !this.isSapCustShipToNameSortCollapsedDownArrow;
  this.isSapCustShipToNameSortCollapsedUpArrow = true;
} 
   }

  }
  sapJobberPayerNumOriginal :string;
  enablingupdate(storedto){
    this.isstoreupdated='';
    this.isBlank='';
    this.updatedstoreconvert=true;
    this.jobberCustId =storedto.jobberCustId;
    this.sapClntCd = storedto.sapClntCd;
    this.sapJobberPayerNum = storedto.sapJobberPayerNum;
    this.sapJobberPayerNumOriginal = storedto.sapJobberPayerNum;
    this.sapCustNum = storedto.sapCustNum;
    this.sapCustShipToName = storedto.sapCustShipToName;
  }
isValid:boolean=false;
isValidForCustShip=false;
  updatestore(){
    this.isstoreupdated="";
    // var isSpecialChar="^[a-zA-Z0-9]+$";
    if(this.jobberCustId.toString() == "" || this.jobberCustId== null || this.jobberCustId== undefined ){
      // this.isstoreupdated="Please Enter Jobber Cust ID";
      return ;
    }
    if(this.sapJobberPayerNum=="" || this.sapJobberPayerNum== null || this.sapJobberPayerNum== undefined  ){
      // this.isstoreupdated="Please Enter SAP Jobber Payer Num";
      return ;
    }
    
    // if(!this.sapJobberPayerNum.match(isSpecialChar)){
    //   this.isValid=true;
    //   // this.isstoreupdated="Please Enter valid SAP Jobber Payer Num";
    //   return;
    // }
    // if(!this.sapCustShipToName.match(isSpecialChar)){
    //   this.isValidForCustShip=true;
    //   // this.isstoreupdated="Please Enter valid SAP Cust Ship Name";
    //   return;
    // }
    let updatingstoreconvert : StoreConvert = new StoreConvert( this.jobberCustId,this.sapClntCd,this.sapJobberPayerNum,this.sapCustNum,this.sapCustShipToName,this.sapJobberPayerNumOriginal);
    this.loading=true;
    this.httpclientService.updatestoreconvert(updatingstoreconvert).subscribe(
      data =>{
        this.isstoreupdated=data.isSaved;
        this.sapJobberPayerNumOriginal=this.sapJobberPayerNum;
        this.loading=false;
      }
  )

  }

  cancelUpdate(){
    this.isstoreupdated="";
    this.modalPopup=true;
  }

  clearField(){
    this.isstoreupdated="";
    this.isValid=false;
    this.isValidForCustShip=false;
  }
  
  showDialog() { 
    this.isstoreupdated=""; 
    this.confirmDialogService.confirmThis("Are you sure You want to Cancel?", function () {  
      this.updatedstoreconvert = false;
      this.getstoreConvert();
    }, function () {  
       
    })  
  } 

  getstoreConvert(){
    this.loading=true;
    this.httpclientService.getStoreConvertDetails(this.search).then(
      data =>{
          this.StoreConvertdetails = data;
          this.intialStoreConvertList= data;
          this.loading=false;
      }
  )
  }


}
